(() => {
  'use strict';
  const root = document.body.dataset.root || '/';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 767px)');
  const menu = document.getElementById('MobileMenu');
  let menuOpen = false, menuRevision = 0, modal = null, returnFocus = null, cartBusy = false;
  const animations = new WeakMap();
  const status = document.getElementById('Sw4gStatus');
  function animate(el, frames, options) {
    if (!el) return Promise.resolve();
    const previous = animations.get(el);
    if (previous) { try { previous.commitStyles(); } catch {} previous.cancel(); }
    const animation = el.animate(frames, {fill: 'forwards', ...options});
    animations.set(el, animation);
    return animation.finished.catch(() => {});
  }
  function lock(active) {
    document.documentElement.classList.toggle('sw4g-modal-open', active);
    document.getElementById('MainContent').inert = active;
    document.querySelector('.neo-header-section').inert = active;
    document.querySelector('footer.neo-footer').inert = active;
    updateBuybar();
  }
  function setMenu(open) {
    if (menuOpen === open) return;
    menuOpen = open;
    const revision = ++menuRevision;
    const panel = menu.querySelector('.neo-staggered-menu-panel');
    const layers = [...menu.querySelectorAll('.neo-staggered-menu-layer')];
    const earbuds = menu.querySelector('.neo-staggered-menu-earbuds');
    const artwork = earbuds.querySelector('img');
    document.querySelectorAll('[data-menu-toggle]').forEach(b => b.setAttribute('aria-expanded', String(open)));
    if (open) {
      returnFocus = document.activeElement;
      menu.hidden = false; menu.inert = false; modal = menu; lock(true);
      if (reduced.matches) {
        [...layers,panel,earbuds,artwork].forEach(el => { animations.get(el)?.cancel(); el.style.transform = 'none'; });
        animate(menu, [{opacity: 0},{opacity: 1}], {duration:160});
      } else {
        menu.style.opacity = '1';
        layers.forEach((el,i) => animate(el, [{transform: getComputedStyle(el).transform === 'none' ? 'translateX(-105%)' : getComputedStyle(el).transform},{transform:'translateX(0)'}], {duration:580,delay:i*70,easing:'cubic-bezier(.76,0,.24,1)'}));
        animate(panel, [{transform:getComputedStyle(panel).transform === 'none' ? 'translateX(-100%)' : getComputedStyle(panel).transform},{transform:'translateX(0)'}], {duration:620,delay:140,easing:'cubic-bezier(.76,0,.24,1)'});
        animate(earbuds,[{transform:'translateY(-115%)',offset:0},{transform:'translateY(3%)',offset:.63},{transform:'translateY(-1%)',offset:.82},{transform:'translateY(0)',offset:1}],{duration:800,delay:220,easing:'cubic-bezier(.22,.65,.25,1)'});
        animate(artwork,[{transform:'rotate(0deg)',offset:0},{transform:'rotate(2.6deg)',offset:.18},{transform:'rotate(-1.8deg)',offset:.4},{transform:'rotate(.95deg)',offset:.62},{transform:'rotate(-.35deg)',offset:.82},{transform:'rotate(0)',offset:1}],{duration:1800,delay:650,easing:'ease-in-out'});
        menu.querySelectorAll('.neo-staggered-menu-links > div').forEach((el,i) => animate(el,[{opacity:0,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:240,delay:80+i*45}));
      }
      menu.querySelector('.neo-staggered-menu-close').focus({preventScroll:true});
    } else {
      menu.inert = true;
      const end = reduced.matches ? animate(menu,[{opacity:getComputedStyle(menu).opacity},{opacity:0}],{duration:120}) : Promise.all([
        animate(earbuds,[{transform:getComputedStyle(earbuds).transform},{transform:'translateY(-115%)'}],{duration:280,easing:'cubic-bezier(.55,0,1,.45)'}),
        animate(artwork,[{transform:getComputedStyle(artwork).transform},{transform:'rotate(0)'}],{duration:180}),
        animate(panel,[{transform:getComputedStyle(panel).transform},{transform:'translateX(-100%)'}],{duration:400,delay:180,easing:'cubic-bezier(.76,0,.24,1)'}),
        ...layers.map((el,i) => animate(el,[{transform:getComputedStyle(el).transform},{transform:'translateX(-105%)'}],{duration:580,delay:i*70,easing:'cubic-bezier(.76,0,.24,1)'}))
      ]);
      modal = null; lock(false); returnFocus?.focus({preventScroll:true});
      end.then(() => { if (revision === menuRevision && !menuOpen) menu.hidden = true; });
    }
  }
  async function renderCart(html) {
    if (!html) {
      const response = await fetch(`${root}?sections=cart-content`,{headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Le panier ne peut pas être actualisé. Rechargez la page.');
      html = (await response.json())['cart-content'];
    }
    if (!html) throw new Error('Le panier ne peut pas être actualisé.');
    const fragment = new DOMParser().parseFromString(html,'text/html').querySelector('[data-cart-content]');
    if (!fragment) throw new Error('Le panier ne peut pas être actualisé.');
    document.querySelectorAll('[data-cart-target],[data-cart-page]').forEach(el => el.replaceChildren(fragment.cloneNode(true)));
    const count = Number(fragment.dataset.count);
    document.querySelectorAll('[data-cart-count]').forEach(el => {el.textContent=String(count);el.hidden=!count;});
  }
  async function openDrawer(id) {
    if (menuOpen) setMenu(false);
    const drawer = document.getElementById(id);
    if (!drawer || modal === drawer) return;
    if (modal) closeDrawer();
    returnFocus=document.activeElement; modal=drawer; drawer.hidden=false;drawer.inert=false;lock(true);
    drawer.classList.add('is-open');
    animate(drawer.querySelector('.sw4g-drawer-panel'),[{transform:'translateX(100%)'},{transform:'translateX(0)'}],{duration:reduced.matches?100:320,easing:'cubic-bezier(.22,1,.36,1)'});
    drawer.querySelector('input, [data-drawer-close]:not(.sw4g-drawer-backdrop)').focus({preventScroll:true});
    if (id==='CartDrawer') {try { await renderCart(); } catch(e) {showCartError(e.message);} }
  }
  function closeDrawer() {
    if (!modal || modal===menu) return;
    const drawer=modal;modal=null;drawer.inert=true;lock(false);returnFocus?.focus({preventScroll:true});
    animate(drawer.querySelector('.sw4g-drawer-panel'),[{transform:getComputedStyle(drawer.querySelector('.sw4g-drawer-panel')).transform},{transform:'translateX(100%)'}],{duration:reduced.matches?100:250,easing:'ease-in'}).then(()=>{if(modal!==drawer){drawer.hidden=true;drawer.classList.remove('is-open');}});
  }
  function showCartError(message) {const el=document.querySelector('.sw4g-cart-error');el.hidden=false;el.textContent=message;}
  async function changeQuantity(key,quantity) {
    if(cartBusy)return;cartBusy=true;
    document.querySelectorAll('[data-cart-key],[data-cart-input]').forEach(el=>el.disabled=true);
    try{
      const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,quantity),sections:['cart-content'],sections_url:location.pathname})});
      const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||'Quantité indisponible.');
      await renderCart(data.sections?.['cart-content']);status.textContent='Panier mis à jour.';
    }catch(e){showCartError(e.message);}finally{cartBusy=false;document.querySelectorAll('[data-cart-key],[data-cart-input]').forEach(el=>el.disabled=false);}
  }
  document.addEventListener('submit', async event=>{
    const form=event.target.closest('.sw4g-product-form');if(!form)return;
    event.preventDefault();if(cartBusy)return;cartBusy=true;
    const buttons=document.querySelectorAll('[data-add-to-cart]');
    const error=form.querySelector('.form-error');error.hidden=true;
    buttons.forEach(b=>{b.disabled=true;b.setAttribute('aria-busy','true');});
    try{
      const body=new FormData(form);body.append('sections','cart-content');body.append('sections_url',location.pathname);
      const response=await fetch(root+'cart/add.js',{method:'POST',body,headers:{Accept:'application/json'}});
      const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||'Impossible d’ajouter ce produit.');
      await renderCart(data.sections?.['cart-content']);status.textContent='Produit ajouté au panier.';await openDrawer('CartDrawer');
    }catch(e){error.textContent=e.message;error.hidden=false;status.textContent=e.message;}
    finally{cartBusy=false;buttons.forEach(b=>{b.disabled=false;b.removeAttribute('aria-busy');});}
  });
  document.addEventListener('click',event=>{
    const el=event.target.closest('button,a');if(!el)return;
    if(el.matches('[data-menu-toggle]')){setMenu(!menuOpen);return;}
    if(el.matches('[data-menu-close]')){setMenu(false);return;}
    if(menu.contains(el)&&el.tagName==='A')setMenu(false);
    if(el.matches('[data-drawer-open]')){event.preventDefault();openDrawer(el.dataset.drawerOpen);return;}
    if(el.matches('[data-drawer-close]')){closeDrawer();return;}
    if(el.matches('[data-cart-key]')){changeQuantity(el.dataset.cartKey,Number(el.dataset.cartQuantity));return;}
    if(el.matches('[data-gallery-index]'))selectImage(el.closest('[data-gallery]'),Number(el.dataset.galleryIndex));
  });
  document.addEventListener('change',event=>{
    const el=event.target;
    if(el.matches('[data-cart-input]'))changeQuantity(el.dataset.cartInput,Math.floor(Number(el.value)||0));
    if(el.matches('[data-variant-select]')){
      const option=el.selectedOptions[0], scope=el.closest('[data-product-section]');
      scope.querySelectorAll('input[name="id"]').forEach(input=>input.value=el.value);
      scope.querySelectorAll('[data-add-to-cart]').forEach(button=>{button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?'Indisponible':'Ajouter au panier';});
      scope.querySelectorAll('.neo-product-price,.neo-mobile-buybar-price').forEach(price=>price.textContent=option.dataset.price);
    }
  });
  document.addEventListener('keydown',event=>{
    if(!modal)return;
    if(event.key==='Escape'){event.preventDefault();if(menuOpen)setMenu(false);else closeDrawer();}
    if(event.key==='Tab'){
      const focusable=[...modal.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea')].filter(el=>el.tabIndex>=0&&!el.hidden&&el.getClientRects().length);
      const first=focusable[0],last=focusable.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
    }
  });
  function selectImage(gallery,index){
    const buttons=[...gallery.querySelectorAll('[data-gallery-index]')],button=buttons[(index+buttons.length)%buttons.length],source=button.querySelector('img'),main=gallery.querySelector('figure img');
    main.src=source.src; if(source.srcset)main.srcset=source.srcset;else main.removeAttribute('srcset');main.alt=source.alt;
    buttons.forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});
    gallery.querySelector('[data-gallery-count]').textContent=`${String(Number(button.dataset.galleryIndex)+1).padStart(2,'0')} / ${String(buttons.length).padStart(2,'0')}`;
    if(!reduced.matches)animate(main,[{opacity:.45},{opacity:1}],{duration:200});
  }
  function updateBuybar(){
    document.querySelectorAll('[data-buybar]').forEach(bar=>{
      const primary=bar.closest('[data-product-section]').querySelector('[data-primary-buy]');if(!primary)return;
      const r=primary.getBoundingClientRect();const visible=r.bottom>48&&r.top<innerHeight-20;
      const show=mobile.matches&&!visible&&!modal&&!menuOpen;
      bar.classList.toggle('is-visible',show);bar.setAttribute('aria-hidden',String(!show));bar.inert=!show;
    });
  }
  let scrollFrame=0;
  addEventListener('scroll',()=>{if(!scrollFrame)scrollFrame=requestAnimationFrame(()=>{updateBuybar();scrollFrame=0;});},{passive:true});
  addEventListener('resize',updateBuybar);
  mobile.addEventListener('change',()=>{if(!mobile.matches&&menuOpen)setMenu(false);updateBuybar();});
  function initialize(scope=document){
    scope.querySelectorAll('[data-gallery]').forEach(gallery=>{
      if(gallery.dataset.ready)return;gallery.dataset.ready='true';let x=0,y=0;
      gallery.addEventListener('touchstart',event=>{x=event.touches[0].clientX;y=event.touches[0].clientY;},{passive:true});
      gallery.addEventListener('touchend',event=>{const dx=event.changedTouches[0].clientX-x,dy=event.changedTouches[0].clientY-y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){const active=gallery.querySelector('[aria-pressed="true"]');selectImage(gallery,Number(active.dataset.galleryIndex)+(dx<0?1:-1));}},{passive:true});
    });
    if(!reduced.matches){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('revealed');observer.unobserve(entry.target);}}),{threshold:.25});scope.querySelectorAll('[data-reveal]').forEach(el=>{el.classList.add('reveal-ready');observer.observe(el);});}
    updateBuybar();
  }
  initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
  if(mobile.matches){const image=new Image();image.src=menu.querySelector('.neo-staggered-menu-earbuds img').src;}
})();
